import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function SectionDivider() {
  return <div className="relative h-px w-full overflow-hidden" data-id="element-492">
      {/* Base line */}
      <div className="absolute inset-0 bg-white/[0.04]" data-id="element-493" />
      {/* Glass shimmer that moves on scroll — CSS animation for performance */}
      <div className="absolute inset-0 h-full" style={{
      background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.08) 20%, rgba(219,127,74,0.12) 50%, rgba(255,255,255,0.08) 80%, transparent 100%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 8s ease-in-out infinite'
    }} data-id="element-494" />
    </div>;
}